import { createServerFn } from "@tanstack/react-start";
import * as client from "openid-client";

import { getKeycloakConfig } from "@onesolution/services";
import { updateAuthSession } from "@onesolution/utils";

export const login = createServerFn().handler(async () => {
	const config = await getKeycloakConfig();

	const code_verifier = client.randomPKCECodeVerifier();
	const code_challenge = await client.calculatePKCECodeChallenge(code_verifier);
	let state = client.randomState();

	const parameters: Record<string, string> = {
		redirect_uri: import.meta.env.VITE_FRONT_AUTH_URL,
		scope: "openid email profile",
		code_challenge,
		code_challenge_method: "S256",
	};

	if (!config.serverMetadata().supportsPKCE()) {
		state = client.randomState();
		parameters.state = state;
	}

	const authUrl = client.buildAuthorizationUrl(config, parameters);

	await updateAuthSession({
		data: {
			code_verifier: code_verifier,
			state,
		},
	});

	return { href: authUrl.href };
});
